import datascreen from './datascreen';
import electricity from './electricity';
import common from './common';
export default { datascreen, electricity, common }